const state = {
  buySkuMap: {},
  ctList: [],
}

const getters = {
}

const mutations = {
  setBuySkuMap (state, payload) {
    state.buySkuMap = payload
  },
  setCtList (state, payload) {
    state.ctList = payload
  },
}

const actions = {

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
